import { useLocation } from "react-router-dom";

export function safeReturnTo(value: string | null, fallback: string): string {
  if (
    !value ||
    value.length > 4096 ||
    !value.startsWith("/") ||
    value.startsWith("//") ||
    value.includes("\\")
  )
    return fallback;
  const url = new URL(value, "https://peer-start.invalid");
  return /^\/me(?:\/(?:passport(?:\/[^/]+)?|stamps\/[^/]+|assessment\/[^/]+))?$/.test(url.pathname)
    ? `${url.pathname}${url.search}${url.hash}`
    : fallback;
}

export function withReturnTo(target: string, origin: string): string {
  const url = new URL(target, "https://peer-start.invalid");
  url.searchParams.set("returnTo", safeReturnTo(origin, "/me"));
  return `${url.pathname}${url.search}${url.hash}`;
}

export function returnLabelKey(target: string): string {
  const path = new URL(target, "https://peer-start.invalid").pathname;
  if (path === "/me") return "navigationBack.route";
  if (path === "/me/passport") return "navigationBack.passport";
  if (path.startsWith("/me/stamps/")) return "navigationBack.topic";
  if (path.startsWith("/me/assessment/")) return "navigationBack.assessment";
  return "navigationBack.area";
}

export function useReturnNavigation(fallback: string) {
  const location = useLocation();
  const to = safeReturnTo(new URLSearchParams(location.search).get("returnTo"), fallback);
  return { to, labelKey: returnLabelKey(to) };
}

export function useOriginLink() {
  const location = useLocation();
  return (target: string) => withReturnTo(target, `${location.pathname}${location.search}${location.hash}`);
}
